import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../../api";

import ParadigmaAsyncSeeker from "../../../../components/ParadigmaAsyncSeeker/ParadigmaAsyncSeeker.js"
import ParadigmaLabeledInput from "../../../../components/ParadigmaLabeledInput/ParadigmaLabeledInput.js"

class CategoriasArticulosModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            Categoria_id: null,
            postVariables: ['Categoria_id',],
            errors: [],
        };
    }

    static propTypes = {
        onSubmit: PropTypes.func,
        action: PropTypes.oneOf(['EDIT']).isRequired,
    }

    resetForm() {
        this.setState({
            Categoria_id: null,
            errors: [],
        });
    }

    getData() {
        const { postVariables } = this.state;
        const { filters, multiSelectIDs } = this.props;
        let data = {
            filters: {
                rubro_id: filters.rubro_id,
                linea_id: filters.linea_id,
                grupo_id: filters.grupo_id,
                marca_id: filters.marca_id,
                proveedor_id: filters.proveedor_id,
                categoria_id: filters.categoria_id,
                somethingSelected: filters.somethingSelected,
                byTitulo: (filters.tituloInputNode && filters.tituloInputNode.value) ? filters.tituloInputNode.value : "",
                byCodigo: (filters.codigoInputNode && filters.codigoInputNode.value) ? filters.codigoInputNode.value : "",

                Articulos_ids: multiSelectIDs && multiSelectIDs() ? multiSelectIDs() : [],
            }
        };
        postVariables.forEach(x => {
            data[x] = this.state[x];
        });
        return data;
    }

    setData(data) {
        if (data.success) {
            this.setState({
                Categoria_id: null,
            })
        }
    }

    setErrors(errors) {
        this.setState({
            errors: errors,
        });
    }

    onChangeField(field, value) {
        this.setState(prevState => {
            let errors = prevState.errors;
            if (errors) errors[field] = null;
            prevState.errors = errors;
            prevState[field] = value;
            return prevState;
        });
    }

    getError(field) {
        let errors = this.state.errors;
        if (errors) return errors[field];
        else return null;
    }

    modalVars() {
        const { action } = this.props;
        if (action == "EDIT") {
            return {
                create: true,
                submitType: "PUT",
                title: "Asignar Categoría a Artículos Seleccionados",
                buttonTitle: "Asignar Categoría a Seleccionados",
                danger: false,
                buttonIcon: "fa fa-superpowers fa-lg",
                successMessage: "La Asignación ha sido éxitosa.",
                saveButton: true,
                saveButtonLabel: "Guardar",
                buttonClass: "",
                disabled: false,
                multiSelectIDs: () => this.props.multiSelectIDs && this.props.multiSelectIDs(),
            };
        }
    }

    render() {
        let vars = this.modalVars();
        const { action, filters } = this.props;
        const selected = vars.multiSelectIDs();
        const msg = (selected == undefined || selected == null || selected == false) ? (
            (filters.somethingSelected) ? (
                "TODOS LOS ARTÍCULOS FILTRADOS"
            ) : (
                "TODOS LOS ARTÍCULOS"
            )
        ) : (
            selected.length == 1 ? (
                `${vars.multiSelectIDs().length} ARTÍCULO`
            ) : (
                `${vars.multiSelectIDs().length} ARTÍCULOS`
            )
        );
        return (
            <ParadigmaModal
                getUrl={(vars.get ? api.gestion.articulos.articulosEditarMany : null)}
                submitUrl={(vars.submitType ? api.gestion.articulos.articulosEditarMany : null)}
                submitType={vars.submitType}

                onGotData={(data) => this.setData(data)}
                onGotErrors={(errors) => this.setErrors(errors)}
                onSubmit={(e) => this.props.onSubmit(e) & this.resetForm()}
                onClose={() => this.resetForm()}
                onPreSubmit={() => this.getData()}

                title={vars.title}

                danger={vars.danger}
                buttonClass={vars.buttonClass}

                successMessage={vars.successMessage}
                missingIdMessage={"Debe seleccionar una fila."}
                saveButtonLabel={vars.saveButtonLabel}
                buttonTitle={vars.buttonTitle}
                buttonIcon={vars.buttonIcon}
                saveButton={vars.saveButton}
                closeButton={true}
                multiSelectIds={vars.multiSelectIDs}
                multiSelect={true}
            >
                <p>
                    Artículos Seleccionados:{" "} <strong>{msg}</strong>
                </p>
                <ParadigmaLabeledInput
                    md={[2, 10]}
                    label={"Categoría"}
                    inputComponent={
                        <ParadigmaAsyncSeeker
                            disabled={vars.disabled}
                            url={api.gestion.articulos.categorias}
                            value={this.state.Categoria_id}
                            displayField="Nombre"
                            parameters={{ paginationEnabled: "False" }}
                            onChange={(data) => this.onChangeField('Categoria_id', (data ? data.id : null))}
                        />
                    }
                    error={() => this.getError('Categoria_id')}
                />
            </ParadigmaModal>
        );
    }
}

export default CategoriasArticulosModal;



// WEBPACK FOOTER //
// ./src/views/Gestion/Articulos/Articulos/CategoriasArticulosModal.js